module.exports = __webpack_public_path__ + "static/media/20170806_15day_0627AT.0190fee2.jpg";